export default __webpack_public_path__ + "static/howto-1-a50fa42bcad1727f96181e27d9540b54.jpg";